import { Component, Input } from '@angular/core';
import { TimeOffType } from '@models/time-off-v3/time-off-type.model';
import { AssignmentEventPayload } from '@time-off-v3/interfaces/assignment-event-payload.interface';

@Component({
    selector: 'app-locked-type',
    templateUrl: './locked-type.template.html',
    styleUrls: ['./locked-type.style.scss'],
})
export class LockedTypeComponent {
    @Input() timeOffType: TimeOffType;
    @Input() payload: AssignmentEventPayload;

    get progress(): number {
        return Math.round(((this.payload.assigned + this.payload.unassigned) / this.payload.total) * 100);
    }
}
